import { render, staticRenderFns } from "./PopupHabitOptionsMenu.vue?vue&type=template&id=1714d4e4&scoped=true"
import script from "./PopupHabitOptionsMenu.vue?vue&type=script&lang=js"
export * from "./PopupHabitOptionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1714d4e4",
  null
  
)

export default component.exports